import {
  AnchorBasic,
  BREAKPOINT,
  H5Style,
  InterZellerMediumFont,
} from '@npco/zeller-design-system'
import styled, { css } from 'styled-components'

const TermsAndConditionsTextCss = css<{ $colour: string }>`
  ${InterZellerMediumFont}
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  color: ${({ $colour }) => $colour};
`

export const BannerTitle = styled.span`
  ${InterZellerMediumFont}
  font-size: 1.5rem;
  line-height: 1.33;
  font-weight: 500;

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    font-size: 2rem;
    line-height: 1.25;
  }
`

export const BannerListItemText = styled.span`
  ${H5Style}
`

export const TermsAndConditionsText = styled.span<{ $colour: string }>`
  ${TermsAndConditionsTextCss}
`

export const Anchor = styled(AnchorBasic)`
  ${TermsAndConditionsTextCss}
  text-decoration: underline;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.GREY_580};
  }
`
